import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-搜索",
  "use": "icon-搜索-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-搜索\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M108.896 34.5077C127.847 55.0168 126.583 87.0051 106.074 105.956C85.5652 124.906 53.5768 123.643 34.6262 103.134C15.6756 82.6249 16.9389 50.6365 37.448 31.6859C57.957 12.7353 89.9454 13.9987 108.896 34.5077ZM116.876 109.229C137.52 86.2337 137.632 50.8717 116.241 27.7212C93.5419 3.15584 55.2268 1.64262 30.6614 24.3413C6.09609 47.04 4.58286 85.3551 27.2816 109.92C49.0019 133.427 85.0215 135.826 109.61 116.101L141.901 151.047C143.775 153.075 146.939 153.2 148.967 151.326C150.995 149.452 151.12 146.289 149.246 144.261L116.876 109.229Z\" fill=\"#656565\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/搜索.svg
// module id = GXxz
// module chunks = 26